export default {
  attachAnalyticsToOpenseaDragon: function (viewer, metadata, customerCode) {
    let meta = Object.assign({}, metadata)
    meta.action = 'view_item'
    meta.customerCode = customerCode
    viewer.addHandler('open', this.genericActionEventToAnalytics, meta)

    meta = Object.assign({}, meta)
    meta.action = 'zoom_nobutton'
    viewer.addHandler('canvas-pinch', this.genericActionEventToAnalytics, meta)
    viewer.addHandler('canvas-scroll', this.genericActionEventToAnalytics, meta)

    meta = Object.assign({}, meta)
    meta.action = 'pan_nobutton'
    viewer.addHandler('canvas-drag-end', this.genericActionEventToAnalytics, meta)

    meta = Object.assign({}, meta)
    meta.action = 'navigator_usage'
    viewer.addHandler('navigator-click', this.genericActionEventToAnalytics, meta)

    meta = Object.assign({}, meta)
    meta.action = 'zoom_button'
    viewer.zoomInButton != null ? viewer.zoomInButton.addHandler('click', this.genericActionEventToAnalytics, meta) : ''
    viewer.zoomOutButton != null
      ? viewer.zoomOutButton.addHandler('click', this.genericActionEventToAnalytics, meta)
      : ''

    meta = Object.assign({}, meta)
    meta.action = 'fullscreen_button'
    viewer.fullPageButton != null
      ? viewer.fullPageButton.addHandler('click', this.genericActionEventToAnalytics, meta)
      : ''

    meta = Object.assign({}, meta)
    meta.action = 'center_button'
    viewer.homeButton != null ? viewer.homeButton.addHandler('click', this.genericActionEventToAnalytics, meta) : ''
  },

  attachAnalyticsToCustomButton: function (element, buttonName, metadata, customerCode) {
    if (element == null) {
      console.warn('Tried to attach google analytics to a null element', buttonName)
      return
    }

    const that = this
    let meta = Object.assign({}, metadata)
    meta.customerCode = customerCode
    meta.action = buttonName + '_button'
    element.addEventListener('click', function (event) {
      event.userData = meta
      that.genericActionEventToAnalytics(event)
    })
  },

  genericActionEventToAnalytics: function (event) {
    const maxEventSendFrequencyMs = 1500
    const eventsTimeouts = {}

    let metadata = event.userData

    if (eventsTimeouts[metadata.action] === undefined) {
      eventsTimeouts[metadata.action] = new Date().getTime() - maxEventSendFrequencyMs - 50
    }

    let now = new Date().getTime()
    let tooFrequent = new Date().getTime() - eventsTimeouts[metadata.action] < maxEventSendFrequencyMs

    if (!tooFrequent) {
      gtag('event', metadata.action, {
        event_category: metadata.customerCode,
        event_label: metadata.author + ' ~ ' + metadata.title + ' ~ ' + metadata.uuid
      })
      eventsTimeouts[metadata.action] = now
    }
  }
}
